<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        Protokolle
                    </h3>
                </div>
                <div class="col text-right">
                    <base-button size="sm" type="secondary" @click="changePage(page)" icon="fas fa-sync-alt"></base-button>
                    <base-button type="primary" size="sm" v-on:click="$router.push('/service/protocols/create')" icon="ni ni-fat-add"></base-button>
                </div>
            </div>
        </div>

        <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <TableHeadFilter :has-filter="false" :has-sort="true" title="#"
                                     @input="changePage(page)"><TableSortControl v-model="tableOptions.sort.id" @input="() => { tableOptions.sort.createdAt = null; changePage(page);}"></TableSortControl></TableHeadFilter>
                    <th v-if="isAdmin">Orga</th>
                    <TableHeadFilter :has-filter="true" :has-sort="false" title="Fragebogen" :dropdown-list="forms" filter-type="dropdown" v-model="tableOptions.filter.form"
                                     @input="changePage(page)"></TableHeadFilter>
                    <TableHeadFilter :has-filter="true" :has-sort="false" title="Referenz"  filter-type="input" v-model="tableOptions.filter.reference"
                                     @input="changePage(page)"></TableHeadFilter>
                    <th>Abgeschlossen</th>
                    <TableHeadFilter :has-filter="true" :has-sort="false" title="Mitarbeiter" :dropdown-list="profiles" filter-type="dropdown" v-model="tableOptions.filter.profile"
                                     @input="changePage(page)"></TableHeadFilter>
                    <TableHeadFilter :has-filter="true" :has-sort="true" v-model="tableOptions.dateFilter.createdAt" title="Erledigt"
                                     filter-type="date" @input="changePage(page)"><TableSortControl v-model="tableOptions.sort.createdAt" @input="() => { tableOptions.sort.id = null; changePage(page);}"></TableSortControl></TableHeadFilter>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <th scope="row">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.id}}</div>
                    </th>
                    <td v-if="isAdmin">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{(typeof row.user.customer === "undefined") ? '' : $store.getters['customer/showCustomerByIRI'](row.user.customer).name}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else v-html="row.form.name"></div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.reference}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else><div v-if="((row.form.questions) && row.form.questions.length>0)" class="d-flex align-items-center">
                            <span class="completion mr-2">{{completion(row.answers,row.form.questions)}}%</span>
                            <div>
                                <base-progress :type="(completion(row.answers,row.form.questions)===100) ? 'success' : 'warning'"
                                               :show-percentage="false"
                                               class="pt-0"
                                               :value="(completion(row.answers,row.form.questions) > 100) ? 100 : completion(row.answers,row.form.questions)"/>
                            </div>
                    </div></div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{(row.profile) ? row.profile.name : '-'}} <br> {{(typeof row.user.location === "undefined") ? '' : "("+$store.getters['location/showLocationByIRI'](row.user.location).name+")"}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{ row.createdAt | formatDateToDay }}</div>
                    </td>

                    <td class="text-right"><div v-if="isLoading" class="loading-button"> </div><div v-else>
                            <template>
                                <base-button v-on:click="$router.push('/service/protocols/edit/'+row.id)" icon="fas fa-eye" type="primary" icon-only></base-button>
                            </template></div>
                    </td>
                </template>
            </base-table>
        </div>

        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination :total="totalitems" v-on:input="changePage" :value="page"></base-pagination>
        </div>

    </div>
</template>

<script>
    import TableHeadFilter from "@/components/TableHeadFilter";
    import TableSortControl from "@/components/TableSortControl";
    export default {
        name: "list",
        components:{TableSortControl, TableHeadFilter},
        props: {
            type: {
                type: String
            },
            title: String
        },
        data() {
            return {
                isMounted: false,
                tableOptions: {
                    filter: {
                        form:null,
                        profile: null,
                        reference: null
                    },
                    dateFilter: {
                        createdAt: null
                    },
                    sort:{
                        id: 'DESC',
                        createdAt: null
                    }},
                tableData: [
                    {
                        id: 0,
                        form: {
                          name: '',
                          questions: [{}]
                        },
                        profile: {
                            name: ''
                        },
                        answers: [{}],
                        reference: "",
                        user: 0,
                        createdAt: '',
                    }
                ],
                totalitems: 0,
                page: 1,
                forms: [],
                isLoadingData: false
            }
        },
        created() {
            this.getForms();
            if (this.$store.getters['profiles/showActiveProfile'] === null && !this.$store.getters['profiles/isReady']) this.$store.dispatch('profiles/getProfiles');
            if (!this.$store.getters['customer/isReady']) this.$store.dispatch('customer/getCustomerCollection');
            if (!this.$store.getters['location/isReady']) this.$store.dispatch('location/getLocationCollection');
            this.changePage(this.page);
        },
        mounted(){
            this.isMounted = true;
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            isLoading() {
                return this.isLoadingData || this.$store.getters['location/isLoading'] || this.$store.getters['customer/isLoading'];
            },
            profiles() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return (!this.$store.getters['profiles/isReady']) ? [] : this.$store.getters['profiles/showProfiles'].sort((a, b) =>{
                    return a.name.localeCompare(b.name);
                });
            },
        },
        methods: {
            changePage(page) {
                this.isLoadingData = true;
                this.getTableData(page).then(
                    response => {
                        this.tableData = response.member;
                        this.totalitems = response.totalItems;
                        this.page = page;
                        this.isLoadingData = false;
                    }
                )
            },
            getTableData(page){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/protocols?`+ this.getUrlExtension(this.tableOptions.filter,this.tableOptions.sort,this.tableOptions.dateFilter)+`&page=` + page, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            },
            getForms(){
                this.getFormData().then(
                    response => {
                        this.forms = response.member;
                    }
                )
            },
            getFormData(){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/forms?pagination=false` , requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            },
            completion(answers,questions) {
                return Math.round((this.isMounted) ? (answers.length/questions.length)*100 : 0);
            }
        }
    }
</script>

<style scoped>

</style>